import React from 'react'
import { View, ViewStyle } from 'react-native'
import { useTheme } from '../../../hooks/theme.hook'

interface BoxProps {
  children?: React.ReactNode
  style?: ViewStyle | ViewStyle[]

  // Margin props
  m?: number // margin (all sides)
  mt?: number // margin-top
  mb?: number // margin-bottom
  ml?: number // margin-left
  mr?: number // margin-right
  mv?: number // margin-vertical (top + bottom)
  mh?: number // margin-horizontal (left + right)

  // Padding props
  p?: number // padding (all sides)
  pt?: number // padding-top
  pb?: number // padding-bottom
  pl?: number // padding-left
  pr?: number // padding-right
  pv?: number // padding-vertical (top + bottom)
  ph?: number // padding-horizontal (left + right)
}

export const Box: React.FC<BoxProps> = ({
  children,
  m,
  mt,
  mb,
  ml,
  mr,
  mv,
  mh,
  p,
  pt,
  pb,
  pl,
  pr,
  pv,
  ph,
  ...otherProps
}) => {
  const theme = useTheme()
  const spacing = theme.spacing

  const spacingStyle: ViewStyle = {
    // Margin
    ...(m !== undefined && { margin: spacing(m) }),
    ...(mt !== undefined && { marginTop: spacing(mt) }),
    ...(mb !== undefined && { marginBottom: spacing(mb) }),
    ...(ml !== undefined && { marginLeft: spacing(ml) }),
    ...(mr !== undefined && { marginRight: spacing(mr) }),
    ...(mv !== undefined && { marginVertical: spacing(mv) }),
    ...(mh !== undefined && { marginHorizontal: spacing(mh) }),

    // Padding
    ...(p !== undefined && { padding: spacing(p) }),
    ...(pt !== undefined && { paddingTop: spacing(pt) }),
    ...(pb !== undefined && { paddingBottom: spacing(pb) }),
    ...(pl !== undefined && { paddingLeft: spacing(pl) }),
    ...(pr !== undefined && { paddingRight: spacing(pr) }),
    ...(pv !== undefined && { paddingVertical: spacing(pv) }),
    ...(ph !== undefined && { paddingHorizontal: spacing(ph) }),
  }

  return (
    <View style={[spacingStyle, { flex: 1 }]} {...otherProps}>
      {children}
    </View>
  )
}

export default Box
